/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.student'),
      field: 'medication.student.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span
          className="tooltip-test"
          title={rowData.medication.student.fullName}
        >
          {rowData.medication.student.fullName}
        </span>
      ),
    },
    {
      title: t('general.classes-names'),
      field: 'medication.student.classesNames',
    },
    {
      title: t('mnt_medication.name'),
      field: 'medication.name',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.medication.name}>
          {rowData.medication.name}
        </span>
      ),
    },
    {
      title: t('mnt_medication.dosage'),
      field: 'medication.dosage',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.medication.dosage}>
          {rowData.medication.dosage}
        </span>
      ),
    },
    {
      title: t('mnt_medication.routeAdministration'),
      field: 'medication.routeAdministration',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span
          className="tooltip-test"
          title={rowData.medication.routeAdministration}
        >
          {rowData.medication.routeAdministration}
        </span>
      ),
    },
    {
      title: t('general.hour'),
      field: 'shouldApplicationHour',
    },
    {
      title: t('mnt_medication.requestDate'),
      field: 'formattedshouldApplicationDate',
    },
    {
      title: t('mnt_medication.requester'),
      field: 'medication.requester',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.requester}>
          {rowData.requester}
        </span>
      ),
    },

    {
      title: t('general.status'),
      field: 'formattedStatus',
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.formattedStatus}>
          {rowData.formattedStatus}
        </span>
      ),
    },

    {
      title: t('general.observations'),
      field: 'medication.observation',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.medication.observation}>
          {rowData.medication.observation}
        </span>
      ),
    },

    {
      title: t('general.internalObs'),
      field: 'observation',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.observation}>
          {rowData.observation}
        </span>
      ),
    },

    {
      title: t('medication_application.updated'),
      field: 'formattedApplicationDate',
    },
    {
      title: t('medication_application.updatedBy'),
      field: 'employeeApplication.name',
      cellStyle: textEllipsis,
    },
  ];
}
